export enum ConnectionState {
  Disconnected = "disconnected",
  Connecting = "connecting",
  Connected = "connected",
  Disconnecting = "disconnecting",
  Error = "error",
  Warning = "warning",
}

export const IS_DEV = process.env.NODE_ENV === "development";

export const GCState = {
  STOPPED: { id: "Stopped", displayName: "Stopped" },
  CALIBRATING: { id: "Calibrating", displayName: "Calibrating" },
  LOADING_LEVEL: { id: "LoadingLevel", displayName: "Loading Level" },
  CATCHING_READY_TO_START: {
    id: "CatchingReadyToStart",
    displayName: "Ready to Start",
  },
  CATCHING: { id: "Catching", displayName: "Catching" },
  CATCHING_PAUSED: { id: "CatchingPaused", displayName: "Paused" },
  SYSTEM_MENU_ACTIVE: {
    id: "SystemMenuActive",
    displayName: "Quest System Menu Active",
  },
  SYSTEM_PAUSED: {
    id: "SystemPaused",
    displayName: "Quest System Is Sleeping",
  },
  SYSTEM_OUT_OF_GUARDIAN: {
    id: "SystemOutOfGuardian",
    displayName: "Quest Is Out Of Guardian",
  },
  UNHANDLED: { id: "Unhandled", displayName: "Unhandled Mode" },
  PAIRING: { id: "Pairing", displayName: "Pairing" },
  CONNECTION_REQUESTED: {
    id: "ConnectionRequested",
    displayName: "Connection Requested",
  },
  EXPECTING_GC_STATE: {
    id: "ExpectingGCState",
    displayName: "Waiting for headset state",
  },
  CHOOSE_PLAYLIST: { id: "ChooseLPlaylist", displayName: "Choose Playlist" },
  CHOOSE_LEVEL: { id: "ChooseLevel", displayName: "Choose Level" },
};

export const ACTIONS = {
  START_CATCHING: "StartCatching",
  PAUSE: "Pause",
  RESUME_CATCHING: "PausedResumeCatching",
  RESTART_CATCHING: "PausedRestartCatching",
  QUIT_CANCEL: "QuitCancel",
  FORCE_CANCEL: "ForceCancel",
  SET_CALIBRATION_MODE: "SetCalibrationMode",
  SET_CASTING: "SetCasting",
  SET_GAME_VOLUME: "SetGameVolume",
  SET_SHOWSCORE: "SetShowScore",
  SET_SHOW_UI: "SetShowUI",
  GET_PLAYLISTS: "GetPlaylists",
  LOAD_LEVEL: "LoadLevel",
  GET_DEFINES: "GetDefines",
  DISCONNECT: "Disconnect",
  UPDATE_SETTING: "UpdateSetting",
  SET_SYSTEM_VOLUME: "SetSystemVolume",
  START_CALIBRATION: "StartCalibration",
  REMEASURE_PLAYER: "RemeasurePlayer",
};

export const INCOMING_MESSAGES = {
  FULL_STATE: "FullState",
  DEFINES: "Defines",
  ALL_PLAYLISTS: "AllPlaylists",
  CLOSING_CONNECTION: "ClosingConnection",
  ERROR: "Error",
  TEST_MESSAGE: "TestMessage",
  ALL_SETTINGS: "AllSettings",
  GC_LOG: "LogState",
  ABORT: "Abort",
};
